import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { useParams, useSearchParams } from 'react-router-dom';
import login from '../../redux/features/login';
import axios from '../../globals/common_utilities/axios_old';
import CONSTANTURL from '../../globals/common_utilities/constanturls';
import { API, FOMRS, APP_ROUTES } from '../../globals/constants';
import Cookies from 'universal-cookie';
import { toast } from 'react-toastify';

const CallBack = () => {
	const cookies = new Cookies();

	let loginRole = useSelector((state) => state.login?.role);
	// let { code } = useParams();
	const [code] = useSearchParams();

	const login = async () => {
		if (loginRole === 'STUDENT') {
			const response = await axios(
				'POST',
				CONSTANTURL[process.env.REACT_APP_CUSTOM_ENV].STUDENT +
					API.END_POINTS.STUDENT_EPIC_LOGIN,
				{ code: `${code}`, type: `${loginRole}` },
				{},
				{}
			)
				.then((response) => {
					console.log('epicResponse', response);
					cookies.set('loginData', response?.data?.data, { path: '/' });
					if (
						response?.data?.data?.role_code === 'SUPER_ADMIN' ||
						response?.data?.data?.role_code === 'STUDIO_ADMIN'
					) {
						console.log(
							'SUPER_ADMIN' || 'STUDIO_ADMIN',
							response.data.data.role_code
						);
						window.location.href = '/dashboard';
					}

					// if (response?.data?.data?.role_code === 'INSTRUCTOR' || 'STUDENT') {
					else {
						console.log(
							'INSTRUCTOR' || 'STUDENT',
							response.data.data.role_code
						);
						// alert('else ', response?.data?.data?.role_code);

						window.location.href = '/veyon';
					}
					return response.data;
				})
				.catch((res) => {
					toast.error(res?.response?.data?.msg1, {
						position: 'bottom-right',
						autoClose: 3000,
						hideProgressBar: true,
						closeOnClick: true,
						pauseOnHover: true,
						draggable: true,
						progress: undefined,
						style: {background: "#FF0000",color: "#ffffff"},
					});
				});
		} else {
			const response = await axios(
				'POST',
				CONSTANTURL[process.env.REACT_APP_CUSTOM_ENV].LOGIN +
					API.END_POINTS.USER_EPIC_LOGIN,
				{},
				{},
				{ code: `${code.get('code')}`, type: `${loginRole}` }
			)
				.then((response) => {
					console.log('epicResponse', response);
					cookies.set('loginData', response?.data?.data, { path: '/' });
					if (
						response?.data?.data?.role_code === 'SUPER_ADMIN' ||
						response?.data?.data?.role_code === 'STUDIO_ADMIN'
					) {
						console.log(
							'SUPER_ADMIN' || 'STUDIO_ADMIN',
							response.data.data.role_code
						);
						window.location.href = '/dashboard';
					}

					// if (response?.data?.data?.role_code === 'INSTRUCTOR' || 'STUDENT') {
					else {
						console.log(
							'INSTRUCTOR' || 'STUDENT',
							response.data.data.role_code
						);
						// alert('else ', response?.data?.data?.role_code);

						window.location.href = '/veyon';
					}
					return response.data;
				})
				.catch((res) => {
					toast.error(res?.response?.data?.msg1, {
						position: 'bottom-right',
						autoClose: 3000,
						hideProgressBar: true,
						closeOnClick: true,
						pauseOnHover: true,
						draggable: true,
						progress: undefined,
						style: {background: "#FF0000",color: "#ffffff"},
					});
				});
		}
	};

	useEffect(() => {
		login();
	}, []);
	return <div></div>;
};

export default CallBack;
